import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  maincontainer: {
    backgroundColor: '#fff',
    width: '70%',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  header: {
    backgroundColor: (props) => props.color,
    height: '3rem',
    color: '#fff',
    fontFamily: 'Roboto',
    fontSize: '18px',
    fontWeight: 500,
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '11px',
  },
  cardContent: {
    padding: '11px',
  },
  title: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 700,
    marginBottom: '4px',
  },
  subTitle: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 700,
    marginBottom: '13px',
  },
  siteAddressDetails: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
  },
  alertsStatusContainer: {
    marginTop: '5px',
    paddingTop: '8px',
    borderTop: '1px solid #E0E0E0',
  },
  alertsCardsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap',
    height: 'auto',
    rowGap: '8px',
    columnGap: '8px',
  },
  alertCard: {
    height: '41px',
    minWidth: '120px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 11px',
    backgroundColor: '#F7F6F7',
    cursor: 'pointer',
  },
  alertCounts: {
    fontFamily: 'Roboto',
    fontSize: '24px',
    lineHeight: '38px',
    marginRight: '11px',
  },
  alertType: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
  },
  buttonContainer: {
    marginTop: '11px',
    display: 'flex',
    justifyContent: 'right',
  },
});
export default useStyles;
